module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionSlotGroupCreateModal",
    attrs: {
      "id": "missionSlotGroupCreateModal",
      "title": _vm.$t('mission.modal.slotGroup.create'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotGroupCreateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createMissionSlotGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.title'),
      "state": _vm.missionSlotGroupCreateTitleState,
      "feedback": _vm.missionSlotGroupCreateTitleFeedback,
      "description": _vm.$t('mission.slotGroup.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotGroupCreateData.title),
      callback: function($$v) {
        _vm.missionSlotGroupCreateData.title = $$v
      },
      expression: "missionSlotGroupCreateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotGroupCreateData.description),
      callback: function($$v) {
        _vm.missionSlotGroupCreateData.description = $$v
      },
      expression: "missionSlotGroupCreateData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.insertAfter'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotGroupCreateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotGroupCreateData.insertAfter),
      callback: function($$v) {
        _vm.missionSlotGroupCreateData.insertAfter = $$v
      },
      expression: "missionSlotGroupCreateData.insertAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot group create actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createMissionSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotGroupCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bec67c72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotGroupCreateModal.vue
// module id = 572
// module chunks = 0